import { Control, Controller } from 'react-hook-form';
import { Checkbox } from 'rsuite';
import { SetupIPAHeader } from '../../SetupIPA/elements/SetupIPAHeader';
import styles from '../SetupIPADadosDeConcorrencia.module.scss';
import { FormValues } from '../interfaces';
import { OtherPrices } from '../SetupIPADadosDeConcorrenciatypes';
import { CHEBOX_OPTIONS, OPTIONS } from '../utils/options';
import { OptionRadioGroup } from './OptionRadioGroup';

export const PriceOptionsSection = ({ control, showOtherPrices }: { control: Control<FormValues>; showOtherPrices: boolean }) => {
  return (
    <div className={styles['setup-ipa__price-preference-competitor']}>
      <SetupIPAHeader
        title="Dados de concorrência no IPA"
        subtitle="Configure quais os dados de concorrência que você quer receber no IPA para a precificação regular."
      />
      <Controller
        name="price_option"
        control={control}
        render={({ field: { ref, ...field } }) => <OptionRadioGroup {...field} options={OPTIONS.price_option.options} inputRef={ref} />}
      />

      {showOtherPrices && (
        <div className={styles['setup-ipa__price-preference-competitor__option-checkbox']}>
          <h4>Outros tipos de preço</h4>
          <p>Defina em detalhes quais preços da concorrência receber no IPA.</p>
          <Controller
            name="other_prices"
            control={control}
            render={({ field }) => (
              <div className={styles['checkbox-container']}>
                {CHEBOX_OPTIONS.other_prices.options.map((option, index) => (
                  <div key={option.key} className={styles['setup-ipa__price-preference-competitor__option-checkbox-item']}>
                    <Checkbox
                      value={option.value as OtherPrices}
                      checked={index === 0 || field.value.includes(option.value as OtherPrices)}
                      disabled={index === 0}
                      onChange={() => {
                        if (index !== 0) {
                          const currentValue = field.value || [];
                          const optionValue = option.value as OtherPrices;
                          const isChecked = currentValue.includes(optionValue);

                          if (!isChecked) {
                            field.onChange([...currentValue, optionValue]);
                          } else {
                            const updatedValues = currentValue.filter(value => value !== optionValue);
                            field.onChange(updatedValues);
                          }
                        }
                      }}
                    >
                      <div className={styles['text-container']}>
                        <h4>{option.title}</h4>
                        <span>{option.subtitle}</span>
                      </div>
                    </Checkbox>
                  </div>
                ))}
              </div>
            )}
          />
        </div>
      )}
    </div>
  );
};
